import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import logo from "../../../../../assets/img/logo.png";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

export default function SidebarLogo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const mini = useSelector((state) => state.app.sidebarMiniActive);
  const barWidth = mini ? 120 : 260;
  const imgWidth = isMobile ? 35 : 64;

  return (
    <a
      href={"https://www.jamezz.nl/"}
      rel={"noreferrer"}
      style={{
        display: "inline-block",
        transition: "transform 200ms ease-in",
        // negate margins, 16px
        transform: `translateX(calc(${barWidth}px / 2 - ${imgWidth}px / 2 - 16px))`,
      }}
      target={"_blank"}
    >
      <img alt={"logo"} src={logo} style={{ width: imgWidth }} />
    </a>
  );
}
